// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Default_collapse__oQ2Uh"};